import { render, staticRenderFns } from "./AuditDepartment.vue?vue&type=template&id=897a08e6&scoped=true"
import script from "./AuditDepartment.vue?vue&type=script&lang=js"
export * from "./AuditDepartment.vue?vue&type=script&lang=js"
import style0 from "./AuditDepartment.vue?vue&type=style&index=0&id=897a08e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a08e6",
  null
  
)

export default component.exports